(() => {
  const initProductEditorial = (scope = document) => {
    const page = scope.querySelector?.('.main-product[data-product-section]') || document.querySelector('.main-product[data-product-section]');
    if (!page || page.dataset.kaboEditorialReady === 'true') return;

    const template = page.querySelector('template[data-kabo-product-editorial-template]');
    if (!template) return;

    const worldLabel = template.dataset.kaboWorldLabel || 'Produkte';
    const worldUrl = template.dataset.kaboWorldUrl || '/collections/all';
    const eyebrow = template.dataset.kaboProductEyebrow || `KABO ${worldLabel}`;
    const productName = template.dataset.kaboProductName || '';

    page.querySelectorAll('.mobile-product-intro .eyebrow, .product-info__desktop-intro .eyebrow').forEach((node) => {
      node.textContent = eyebrow;
    });

    const breadcrumb = page.querySelector('.product-breadcrumb');
    const backLink = breadcrumb?.querySelector('.product-back-link');
    if (backLink) {
      backLink.href = worldUrl;
      const label = backLink.querySelector('span:last-child');
      if (label) label.textContent = `Zurück zu KABO ${worldLabel}`;
    }

    if (breadcrumb && !breadcrumb.querySelector('.product-breadcrumb__world')) {
      const context = document.createElement('span');
      context.className = 'product-breadcrumb__world';
      context.textContent = productName ? `KABO ${worldLabel} · ${productName}` : `KABO ${worldLabel}`;
      breadcrumb.appendChild(context);
    }

    const layout = page.querySelector('.product-layout');
    const alreadyRendered = page.querySelector('.kabo-product-assurance, .kabo-product-story');
    if (layout && !alreadyRendered) {
      layout.insertAdjacentElement('afterend', document.createElement('span'));
      const anchor = layout.nextElementSibling;
      const fragment = template.content.cloneNode(true);
      anchor.replaceWith(fragment);
    }

    template.remove();
    page.dataset.kaboEditorialReady = 'true';
  };

  const init = () => initProductEditorial(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => initProductEditorial(event.target));
})();
